
import { useContext } from "react";
import { CenterContext, ClassesContext, StaffContext, StudentsContext, UserContext } from "../../../Context";


/**
 * Custom hook for accessing multiple context values.
 * @returns {Object} An object containing various context values and functions:
 * @property {Object} center - Current center data from CenterContext
 * @property {Array} locations - Array of locations from CenterContext
 * @property {Array} staff - Array of staff members from StaffContext
 * @property {Function} findStaff - Function to find staff members from StaffContext
 * @property {Function} findStaffName - Function to find a staff member's name from StaffContext
 * @property {Function} getStaffRole - Function to get staff role from StaffContext
 * @property {Array} classes - Array of classes from ClassesContext
 * * @property {Function} findClass - Function to find a class from ClassesContext
 * @property {Function} findClasses - Function to find classes from ClassesContext
 * @property {Array} activeClasses - Array of active classes from ClassesContext
 * @property {Array} classDays - Array of class days from ClassesContext given a class ID
 * @property {Array} teachersClasses - Array of teacher's classes from ClassesContext given a staff ID
 * @property {Array} todaysClasses - Array of today's classes from ClassesContext
 * @property {Object} user - Current user data from UserContext
 */
export default function useCTX() {
    const { center, locations } = useContext(CenterContext)
    const { classes, findClasses, activeClasses, classDays, teachersClasses, todaysClasses, findClass } = useContext(ClassesContext)
    const { staff, findStaff, getStaffRole, findStaffName  } = useContext(StaffContext)
    const { user } = useContext(UserContext)
    const { students, findStudent } = useContext(StudentsContext)
    return {
        center, locations, staff, findStaff, getStaffRole, findStaffName, classes, findClass, findClasses, activeClasses, classDays, teachersClasses, todaysClasses, user, findStudent, students
    }
}